import React, { FC, useEffect, useState } from 'react';
import {
  PageWrapper,
  useShowConfirmationPopup,
  useShowAlertPopup,
  User,
  Lead,
  Customer,
  GenericList,
  Product,
  LoadingAnimation,
  FilterListInput,
  AdditionalLeadListContent,
} from '@dew21/ui';
import axios from 'axios';

export const Leads: FC = (props) => {
  const showConfirmationPopup = useShowConfirmationPopup();
  const showNotificationBanner = useShowAlertPopup();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<User[] | null>(null);
  const [customers, setCustomers] = useState<Customer[] | null>(null);
  const [products, setProducts] = useState<Product[] | null>(null);
  const [leads, setLeads] = useState<Lead[] | null>(null);
  const [filteredLeads, setFilteredLeads] = useState<Lead[] | null>(null);

  const fetchUsers = async () => {
    return axios.get('/api/users');
  };

  const fetchProducts = async () => {
    return axios.get('/api/product/all');
  };

  const fetchLeads = async () => {
    return axios.get('/api/leads');
  };

  const fetchCustomers = async () => {
    return axios.get('/api/customers');
  };

  useEffect(() => {
    setIsLoading(true);
    fetchUsers()
      .then((response) => setUsers(response.data))
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (users) {
      fetchCustomers()
        .then((response) => setCustomers(response.data))
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  }, [users]);

  useEffect(() => {
    if (customers) {
      fetchProducts()
        .then((response) => setProducts(response.data))
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  }, [customers]);

  useEffect(() => {
    if (products) {
      fetchLeads()
        .then((response) => {
          setLeads(response.data);
          setFilteredLeads(response.data);
          setIsLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  }, [products]);


  return (
    <PageWrapper
      breadCrumb={[{ title: 'Leads', path: '/leads' }]}
      marginal={{
        items: [],
      }}>

      {
        (leads && leads.length > 0) && <FilterListInput
          id={'filter-leads'}
          label={'Leadsuche'}
          onChange={(value: string | null) => {
            if (value && leads) {
              const condition = leads.filter((lead) => {

                const sender = users?.find((user) => user.id === lead.senderId);
                const matchingStringSender = sender ? `${sender.firstName} ${sender.familyName}`.toLowerCase() : `${lead.senderId}`.toLowerCase();

                const receiver = users?.find((user) => user.id === lead.receiverId);
                const matchingStringReceiver = receiver ? `${receiver.firstName} ${receiver.familyName}`.toLowerCase() : `${lead.receiverId}`.toLowerCase();

                const customer = customers?.find((customer) => customer.id === lead.customerId);
                const matchingStringCustomer = customer ? `${customer.name}`.toLowerCase() : `${lead.customerId}`.toLowerCase();

                const product = products?.find((product) => product.id === lead.productId);
                const matchingStringProduct = product ? `${product.name}`.toLowerCase() : `${lead.productId}`.toLowerCase();

                const lowerValue = value.toLowerCase();
                if (matchingStringSender.includes(lowerValue) || matchingStringCustomer.includes(lowerValue) || matchingStringReceiver.includes(lowerValue) || matchingStringProduct.includes(lowerValue)) {
                  return lead;
                }
              }).filter((lead) => lead !== null) || leads;
              setFilteredLeads(condition);
            } else {
              setFilteredLeads(leads);
            }
          }}
          placeholder={'Unternehmensname oder Vorname Nachname'}/>
      }

      {
        (filteredLeads !== null && filteredLeads.length > 0 && !isLoading) ?
          <GenericList
            collapsible={true}
            displayColumnNames={true}
            columns={[
              {
                name: 'senderId',
                displayName: 'Ersteller',
                sortable: true,
                formatFn: (value) => {
                  const user = users?.find((user) => user.id === value);
                  return user ? `${user.firstName} ${user.familyName}` : 'Nicht gefunden';
                },
              },
              {
                name: 'receiverId',
                displayName: 'Empfänger',
                sortable: true,
                formatFn: (value) => {
                  const user = users?.find((user) => user.id === value);
                  return user ? `${user.firstName} ${user.familyName}` : 'Nicht gefunden';
                },
              },
              {
                name: 'customerId',
                displayName: 'Kunde',
                sortable: true,
                formatFn: (value) => {
                  const customer = customers?.find((customer) => customer.id === value);
                  return customer ? customer.name : 'Nicht gefunden';
                },
              },
              {
                name: 'productId',
                displayName: 'Product',
                sortable: true,
                formatFn: (value) => {
                  const product = products?.find((customer) => customer.id === value);
                  return product ? product.name : 'Nicht gefunden';
                },
              },
            ]}
            items={filteredLeads}
            additionalRenderFn={(lead) => (
              <AdditionalLeadListContent
                lead={lead}
                users={users || []}
                products={products || []}
                customers={customers || []}/>
            )}/> :
          <>Keine Leads gefunden.</>
      }

      {
        isLoading && <LoadingAnimation transparent overlay/>
      }

    </PageWrapper>
  );
};
